export default "__VITE_ASSET__f7c6e126__"